(() => {
    const initCheckoutButton = () => {
        const CHECKOUT_BUTTON_SELECTOR = '[data-checkout-button]';
        const LOADING_SPINNER_SELECTOR = '[data-loading-spinner]';
        
        const checkoutButton = document.querySelector(CHECKOUT_BUTTON_SELECTOR);
        if (!checkoutButton) return;
        const loadingSpinner = checkoutButton.querySelector(LOADING_SPINNER_SELECTOR);

        checkoutButton.addEventListener('click', () => {
            checkoutButton.classList.add('loading');
            if (loadingSpinner) {
                loadingSpinner.classList.remove('hidden');
            }
        });
    }

    const initRadioButtons = () => {
        const PRICE_CONTAINER_SELECTOR = '[data-price-container]';
        const PRICE_ELEMENT_SELECTOR = '[data-price]';
        const QUANTITY_RADIO_SELECTOR = 'input[type="radio"][name="quantity"]';

        const quantityRadios = document.querySelectorAll(QUANTITY_RADIO_SELECTOR);
        const priceContainer = document.querySelector(PRICE_CONTAINER_SELECTOR);
        const priceItem = priceContainer?.querySelector(PRICE_ELEMENT_SELECTOR) || document.querySelector(PRICE_ELEMENT_SELECTOR);

        const basePriceRaw = Number.parseInt(priceContainer?.dataset.basePrice || '0', 10);
        const basePrice = Number.isNaN(basePriceRaw) ? 0 : basePriceRaw / 100;

        const updatePriceFromQuantity = (quantityValue, discountValue) => {
            if (!priceItem) return;

            const quantity = Number.parseInt(quantityValue, 10);
            if (Number.isNaN(quantity)) return;

            const totalBeforeDiscount = quantity * basePrice;
            if (discountValue === undefined || discountValue == '0') {
                priceItem.textContent = `$${totalBeforeDiscount.toFixed(2)}`;
                return;
            }

            const discount = Number.parseFloat(discountValue || '0');
            const totalAfterDiscount = totalBeforeDiscount - discount;
            priceItem.innerHTML = `<span class="v:discounted-price">$${totalBeforeDiscount.toFixed(2)}</span> <span>$${totalAfterDiscount.toFixed(2)}</span>`;
        };

        quantityRadios.forEach((radio) => {
            radio.addEventListener('click', () => {
                updatePriceFromQuantity(radio.value, radio.dataset.discount);
            });
        });

        const selectedRadio = document.querySelector(`${QUANTITY_RADIO_SELECTOR}:checked`);
        if (selectedRadio) {
            updatePriceFromQuantity(selectedRadio.value);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            initCheckoutButton();
            initRadioButtons();
        });
    } else {
        initCheckoutButton();
        initRadioButtons();
    }
})();
